import { FirmWithLenses, SimpleLensView } from "generated/graphql";
import { useAppSelector } from "redux/hooks";
import { selectFirmsWithLenses, selectLenses } from "redux/slices/client/client.query";

function useLensesForLensIds(lensIds: number[]): SimpleLensView[] {
  const lenses = useAppSelector(selectLenses);
  return lenses.filter((l) => lensIds.includes(l.id));
}

function useFirmsForFirmIds(firmIds: number[]): FirmWithLenses[] {
  const firms = useAppSelector(selectFirmsWithLenses);
  return firms.filter((f) => firmIds.find((id) => id === f.id));
}

export { useLensesForLensIds, useFirmsForFirmIds };
